import React, { useEffect, useMemo, useState } from 'react';

import { loadImage } from './utils';
import { IslandModel } from '../../models/islandModel';
import LoadingIndicator from '../shared/LoadingIndicator';
import Island from './Island';
import useWindowSize from '../../hooks/useWindowSize';
import isIOS from '../../utils/UserAgent';

interface OwnProps {
  island: IslandModel,
}

const IslandWrap = ({ island }: OwnProps): React.ReactElement => {
  const [islandImageDownloaded, setIslandImageDownloaded] = useState(false);

  const {
    theme: {
      largeImageUrl: largeIslandImageUrl,
    },
  } = island;

  const initTimeout = isIOS() ? 100 : 0;

  const { width, height } = useWindowSize(initTimeout);

  /**
   * By updating the key value of a component, we can force a rerender. We need to do this in order
   * to readjust the the island.
   */
  const [keyValue, setKeyValue] = useState(0);
  const oldWidth = useMemo(() => width, [keyValue]);
  const oldHeight = useMemo(() => height, [keyValue]);

  useEffect(() => {
    if (Math.abs(width - oldWidth) > 150 || Math.abs(height - oldHeight) > 150) {
      setKeyValue(keyValue + 1);
    }
  }, [width, height]);

  const islandImage = largeIslandImageUrl;

  useEffect(() => {
    const loadIslandImage = async () => {
      setIslandImageDownloaded(false);
      await loadImage(islandImage);
      setIslandImageDownloaded(true);
    };

    loadIslandImage();
  }, [islandImage]);

  /**
   * We show a loader until the island image has actually been cached in the browser.
   */
  if (!islandImageDownloaded) {
    return <LoadingIndicator />;
  }

  return (
    <Island key={keyValue} island={island} />
  );
};

export default IslandWrap;
